module.exports = __webpack_public_path__ + "img/german-flag.390882b6.svg";